import { Controller } from "@hotwired/stimulus";

// Keeps a <video> from downloading anything until the page has finished
// loading (posters, images, fonts) and the video is near the viewport.
// With autoplay (the default) it plays while visible and pauses off-screen;
// without it, it only attaches the source so page scripts can play it on cue.
// A play() call before that point (e.g. a ScrollTrigger firing while GSAP
// still holds the element off-screen) attaches the source right away.
export default class extends Controller {
  static values = { src: String, autoplay: { type: Boolean, default: true } };

  connect() {
    this.element.addEventListener("play", this.#attach);
    this.observer = new IntersectionObserver(
      ([entry]) => this.#visibilityChanged(entry.isIntersecting),
      { rootMargin: "50% 0px" }
    );

    if (document.readyState === "complete") this.#observe();
    else window.addEventListener("load", this.#observe, { once: true });
  }

  disconnect() {
    this.element.removeEventListener("play", this.#attach);
    window.removeEventListener("load", this.#observe);
    this.observer.disconnect();
  }

  #observe = () => this.observer.observe(this.element);

  #attach = () => {
    if (this.element.getAttribute("src")) return;
    this.element.preload = "auto";
    this.element.src = this.srcValue;
  };

  #visibilityChanged(visible) {
    if (visible) this.#attach();

    if (!this.autoplayValue) return;
    if (visible) this.element.play().catch(() => {});
    else this.element.pause();
  }
}
